import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import {
  IpoClickOutsideDirective,
  IpoLanguageService,
} from '@ip-only/front-end-library';
import {
  DropdownOptionWithIcon,
  enFlagUrl,
  fiFlagUrl,
  svFlagUrl,
} from '../../../../../../../shared/language-chooser/language-chooser-entities';

type SigningLanguage = 'en' | 'sv' | 'fi';

@Component({
  selector: 'app-signing-language-chooser',
  standalone: true,
  imports: [AsyncPipe, IpoClickOutsideDirective],
  templateUrl: './signing-language-chooser.component.html',
  styleUrl: './signing-language-chooser.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SigningLanguageChooserComponent {
  private languageService = inject(IpoLanguageService);

  languageClicked = signal<SigningLanguage | null>(null);

  expanded = false;

  language$ = this.languageService.getLanguage$();

  languages: SigningLanguage[] = ['en', 'sv', 'fi'];

  languageMap: Record<
    SigningLanguage,
    DropdownOptionWithIcon<SigningLanguage>
  > = {
    en: {
      value: 'en',
      label: 'EN',
      icon: enFlagUrl,
    },
    sv: {
      value: 'sv',
      label: 'SV',
      icon: svFlagUrl,
    },
    fi: {
      value: 'fi',
      label: 'FI',
      icon: fiFlagUrl,
    },
  };

  closeDropdown(): void {
    this.expanded = false;
  }

  toggleDropdown(): void {
    this.expanded = !this.expanded;
  }

  selectOption(language: SigningLanguage): void {
    this.languageService.setLanguage(language);
    this.closeDropdown();
    this.languageClicked.set(language);
  }

  onOptionClick(event: Event, language: SigningLanguage): void {
    event.preventDefault();
    this.selectOption(language);
  }

  closedByKey(): void {
    this.closeDropdown();
  }

  isSupportedLanguage(language: string): language is SigningLanguage {
    return language === 'en' || language === 'sv' || language === 'fi';
  }

  getSelectedLanguage(language: string | null): SigningLanguage {
    return this.isSupportedLanguage(language ?? '')
      ? (language as SigningLanguage)
      : 'en';
  }
}
